import { TableCellType } from "../table";
import ClickableBadgeWithOnClickEmitter from "./cellTypes/ClickableBadgeWithOnClickEmitter";
import CustomRenderCell from "./cellTypes/CustomRenderCell";
import DiagnosisWithOverflowCell from "./cellTypes/DiagnosisWithOverflowCell";
import EligibilityActionItemsCell from "./cellTypes/EligibilityActionItemsCell";
import MultilineCellWithCopy from "./cellTypes/MultilineCellWithCopy";
import MultilineCellWithLeftBorder from "./cellTypes/MultilineCellWithLeftBorder";
import StageWithOverflowCell from "./cellTypes/StageWithOverflowCell";
import StringCell from "./cellTypes/StringCell";
import TagCell from "./cellTypes/TagCell";
import TagWithOverflowCell from "./cellTypes/TagWithOverflowCell";

interface TableCellProps {
  type: TableCellType;
  value: any;
  header?: string;
  onClickableBadgeClick?: (id: string) => void;
  [key: string]: any;
}

/**
 * Dispatches a cell to its typed renderer.
 *
 * @param props - Cell type, value, and cell-specific handlers
 * @returns Rendered cell content
 */
export const TableCell = (props: TableCellProps) => {
  switch (props.type) {
    case TableCellType.STRING:
      return <StringCell value={props.value} />;
    case TableCellType.MULTILINE_CELL_WITH_LEFT_BORDER:
      return <MultilineCellWithLeftBorder value={props.value} />;
    case TableCellType.MULTILINE_CELL_WITH_COPY:
      return <MultilineCellWithCopy value={props.value} />;
    case TableCellType.CLICKABLE_BADGE_WITH_ON_CLICK:
      return (
        <ClickableBadgeWithOnClickEmitter
          value={props.value}
          onClick={props.onClickableBadgeClick}
        />
      );
    case TableCellType.TAG_CELL:
      return <TagCell value={props.value} />;
    case TableCellType.TAG_WITH_OVERFLOW:
      return <TagWithOverflowCell value={props.value} />;
    case TableCellType.ELIGIBILITY_ACTION_ITEMS:
      return <EligibilityActionItemsCell value={props.value} />;
    case TableCellType.DIAGNOSIS_WITH_OVERFLOW:
      return <DiagnosisWithOverflowCell value={props.value} />;
    case TableCellType.STAGE_WITH_OVERFLOW:
      return <StageWithOverflowCell value={props.value} />;
    case TableCellType.CUSTOM_RENDER:
      return <CustomRenderCell value={props.value} />;
    default:
      if (process.env.NODE_ENV !== "production") {
        console.warn(
          `[RisaCustomTable] Unsupported cell type "${props.type}". Falling back to STRING.`,
        );
      }
      return <StringCell value={props.value} />;
  }
};

export default TableCell;
